import { ReduxService } from 'dashboard-services/services';

import { imagePreviewActions } from 'actions/modules/tools';

export const imagePreviewInitialState = {
  isOpen: false,
  fileId: undefined,
  provider: undefined
}

export default (state = imagePreviewInitialState, action) => {
  switch (action.type) {
    case imagePreviewActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}